import { AutogenModelTenfourControl, AutogenRowTenfourControl } from "./autogen/AutogenModelTenfourControl";

export class ModelTenfourControl extends AutogenModelTenfourControl<RowTenfourControl> {
	constructor() {
		super(RowTenfourControl);
	}
}

export class RowTenfourControl extends AutogenRowTenfourControl {
}